import React from 'react';
import './XTAMSpinner.css';

export type XTAMSpinnerVariant = 'fullscreen' | 'inline' | 'small' | 'tiny';

interface XTAMSpinnerProps {
  /** fullscreen: overlay que cubre toda la pantalla (login, carga inicial). inline: dentro de contenido. small: para botones/cards */
  variant?: XTAMSpinnerVariant;
  /** Mensaje opcional debajo del spinner */
  message?: string;
}

const baseUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
/** Espacio en el nombre del archivo: codificar para que el logo cargue en todos los entornos */
const logoXtam = `${baseUrl}/img/${encodeURIComponent('LOGO XTAM.png')}`;

const XTAMSpinner: React.FC<XTAMSpinnerProps> = ({
  variant = 'inline',
  message,
}) => {
  return (
    <div className={`xtam-spinner xtam-spinner--${variant}`} role="status" aria-label={message || 'Cargando'}>
      <div className="xtam-spinner__visual">
        <div className="xtam-spinner__ring">
          <div className="xtam-spinner__ring-segment" />
          <div className="xtam-spinner__ring-segment" />
        </div>
        <div className="xtam-spinner__logo-wrapper">
          <img
            src={logoXtam}
            alt="XTAM"
            className="xtam-spinner__logo"
          />
        </div>
      </div>
      {message && <p className="xtam-spinner__message">{message}</p>}
    </div>
  );
};

export default XTAMSpinner;
